import * as React from "react";

interface Label {
  as?: string;
  inputId?: string;
  children: React.ReactNode;
}

const Label: React.FC<Label> = (props: Label) => {
  const { as, inputId, children } = props;

  if (as === "legend") {
    return (
      <legend className="cursor-pointer font-serif font-semibold text-dw-grey-14 text-l">
        {children}
      </legend>
    );
  }

  return (
    <label
      htmlFor={inputId}
      className="cursor-pointer font-serif font-semibold text-dw-grey-14 text-l"
    >
      {children}
    </label>
  );
};

export default Label;
